import React, { useState } from 'react';
import { formatLabel } from '../../../customers/components/reportTable';
import arrowUpIcon from '../../../../../../assets/image/arrow_up.svg';
import arrowDownIcon from '../../../../../../assets/image/arrowD.svg';

export default function ProfitByProductTableBodyComponent({
	data,
	params,
	periods,
	selectedColumnsList,
}) {
	const [selectedId, setSelectedId] = useState(null);
	const handleArrowIcon = (id) => {
		if (selectedId === id) {
			setSelectedId(null);
		} else {
			setSelectedId(id);
		}
	};
	return data.flatMap((item, profitIndex) => {
		const ItemRow = (
			<tr key={`product-${profitIndex}`}>
				<td className="name-col">
					<div className="d-flex gap-5 align-items-center">
						<img
							src={selectedId === item.product_id ? arrowUpIcon : arrowDownIcon}
							alt="arrow-icon"
							className="cursor-pointer"
							onClick={() => handleArrowIcon(item.product_id)}
						/>
						<div className="tex-black fw-light">
							{item.product_name} ({item.product_code})
						</div>
					</div>
				</td>
				{periods.map((p, i) => {
					const key = formatLabel(p.label);
					const metrics = item.metrics[key] || {};

					return selectedColumnsList.map((m, idx) => (
						<td key={`item-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
					));
				})}
			</tr>
		);

		const batchRows =
			item.batches && item.batches.length > 0 && selectedId === item.product_id
				? item.batches.map((batch, batchIndex) => (
						<tr key={`product-${profitIndex}-${batchIndex}`}>
							<td
								className="name-col"
								style={{ paddingLeft: '30px' }}
							>
								{batch.batch_no}
							</td>

							{periods.map((p, i) => {
								const key = formatLabel(p.label);
								const metrics = batch.metrics[key] || {};

								return selectedColumnsList.map((m, idx) => (
									<td key={`product-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
								));
							})}
						</tr>
					))
				: [];

		return [ItemRow, ...batchRows];
	});
}
